var React = require('react');

function TriangleMore (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"id":"Triangle","fill":"#1EAEF1","transform":"translate(50.000000, 50.000000) rotate(180.000000) translate(-50.000000, -50.000000) ","points":"50 0 100 100 0 100"}));
}

TriangleMore.defaultProps = {"viewBox":"0 0 100 100","version":"1.1"};

module.exports = TriangleMore;

TriangleMore.default = TriangleMore;
